<template>
  <b-modal no-close-on-backdrop ref="my-modal" size="xl" hide-footer title="Preguntas" v-on:hide="onModalHide()">

    <div class="lessons-model">
      <input type="text" class="form-control bg-light border-0 small" placeholder="Buscar por título"
        aria-label="Search" aria-describedby="basic-addon2" v-model="searchQuestions" v-on:keyup="loadQuestions">
      <div class="row">
        <div class="col-md-6">
          <b-form-group id="input-group-3" label="Categoría:  " label-for="input-3">
            <b-form-select id="input-3" v-model="category" :options="categoryList" class="ml-2 mt-2"></b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group id="input-group-3" label="Subcategoría:  " label-for="input-3">
            <b-form-select id="input-3" v-model="subcategory" :options="subCategoryList"
              class="ml-2 mt-2"></b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group id="input-group-3" label="Área de conocimiento:  " label-for="input-3">
            <b-form-select id="input-3" v-model="knowledgeArea" :options="knowledgeAreaLIst"
              class="ml-2 mt-2"></b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group id="input-group-3" label="Competencias:  " label-for="input-3">
            <b-form-select id="input-3" v-model="competencies" :options="competenciesLIst"
              class="ml-2 mt-2"></b-form-select>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group id="input-group-3" label="Dificultad:  " label-for="input-3">
            <b-form-select id="input-3" v-model="difficulty" :options="difficultyList" class="ml-2 mt-2"
              aria-selected="true"></b-form-select>
          </b-form-group>
        </div>
      </div>


      <multiselect v-model="selectedTags" id="ajax" label="name" track-by="name" placeholder="Buscar por tags"
        open-direction="bottom" :options="tags" :multiple="true" :searchable="true" :loading="isLoading"
        :internal-search="false" :clear-on-select="false" :close-on-select="false" :options-limit="300" :limit="3"
        :limit-text="limitText" :max-height="600" :show-no-results="false" :hide-selected="true"
        @search-change="asyncFind">
        <template slot="tag" slot-scope="{ option, remove }"><span class="mb-2 custom__tag"><span>{{ option.name
              }}</span><span class="custom__remove" @click="remove(option)">❌</span></span></template>
        <template slot="clear" slot-scope="props">
          <div class="multiselect__clear" v-if="selectedTags.length" @mousedown.prevent.stop="clearAll(props.search)">
          </div>
        </template><span slot="noResult">No se encontraron tags</span>
      </multiselect>

      <button class="btn btn-primary mt-5 mb-4 mr-3 float-right" @click="loadQuestions" type="button">
        <font-awesome-icon icon="fas fa-search" />&nbsp;Buscar
      </button>
    </div>

    <div class="lessons-model mt-3">
      <table class="table">
        <thead>
          <tr>
            <th>Titulo</th>
            <th>Dificultad</th>
            <th>Subcategoría</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody v-for="(question, index) in questions" :key="index">
          <tr>
            <td>{{ question.uniqueName }}</td>
            <td>{{ question.difficulty.description }}</td>
            <td>{{ question.subCategory.description }}</td>
            <td style="width: 100px">
              <div class="col col-sm-6 col-md-6 col-lg-6 text-center">
                <b-button class="mt-3" v-on:click="saveQuestion(question.id,)">Agregar</b-button>
              </div>
            </td>
            <td style="width: 100px">
              <div class="col col-sm-6 col-md-6 col-lg-6 text-center">
                <router-link :to="{ name: 'QuestionsEdit', params: { id: question.id}}" target="_blank">
                  <b-button class="mt-3">Ver</b-button>
                </router-link>
              </div>
            </td>
          </tr>
        </tbody>

        <tbody v-if="questions.length === 0">
          <tr>
            <td colspan="2" class="td-nhd">No hay datos</td>
          </tr>
        </tbody>
      </table>
    </div>

  </b-modal>
</template>


<script>
import Multiselect from 'vue-multiselect'
import axios from "axios";
import qs from 'qs'


export default {
  props: {
    parentModel: String,
  },
  components: {
    Multiselect
  },
  data() {
    return {
      category: null,
      subcategory: null,
      knowledgeArea: null,
      competencies: null,
      difficulty: null,
      categoryList: [],
      subCategoryList: [],
      knowledgeAreaLIst: [],
      competenciesLIst: [],
      difficultyList: [],
      questions: [],
      searchQuestions: "",
      selectedTags: [],
      tags:[],
      isLoading: false,
    }
  },
  methods: {
    limitText (count) {
      return `and ${count} other countries`
    },
    saveQuestion(questionId) {
      this.$emit('saveQuestion', questionId);
    },
    asyncFind (query) {
      this.isLoading = true;
      if (query === '') return;
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/tag/list/" + query, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.tags = response.data;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    clearAll () {
      this.selectedTags = [];
    },
    async loadDifficulty() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/difficulty/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let arr = response.data;
          this.difficultyList.push({
            text: "Selecciona una dificultad",
            value: null,
          });


          for (let item of arr.sort((a, b) => a.id - b.id)) {
            this.difficultyList.push({ text: item.description, value: item.id });
          }

          this.loadKnowledge();
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    async loadCompetences() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/competences/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let arr = response.data;
          this.competenciesLIst.push({
            text: "Selecciona una competencia",
            value: null,
          });
          for (let item of arr) {
            this.competenciesLIst.push({ text: item.description, value: item.id });
          }
          this.loadCategories();
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    async loadKnowledge() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/knowledgearea/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let arr = response.data;
          this.knowledgeAreaLIst.push({
            text: "Selecciona un Tipo de pensamiento",
            value: null,
          });
          for (let item of arr) {
            this.knowledgeAreaLIst.push({
              text: item.description,
              value: item.id,
            });
          }
          this.loadCompetences();
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    loadCategories() {
      let loader = this.$loading.show({});
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/categories/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let arr = response.data;
          this.categoriesResponse = arr
          this.categoryList.push({
            text: "Selecciona una categoría",
            value: null,
          });
          for (let item of arr) {
            if (item.deleted) {
              continue;
            }
            this.categoryList.push({ text: item.description, value: item.id });
          }

          loader.hide();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    populateSelectSubcategories() {
      this.subCategoryList = [];
      if (this.category) {
        let relatedCategories = this.categoriesResponse.find(obj => obj.id === this.category).subcategoryList;
        this.subCategoryList.push({text: 'Selecciona una subcategoría', value: null})

        for (let item of relatedCategories) {
          if(item.deleted) {
            continue;
          }
          this.subCategoryList.push({text: item.description, value: item.id})
        }
      } else {
        this.subcategory = null;
      }
    },
    loadQuestions() {

      const names = this.selectedTags.map(objeto => objeto.name);
      const tagslist = names.join(',');
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/question/getQuestionListforAdd", {
          params: {
            search: this.searchQuestions,
            tags: tagslist,
            subcategories: this.getSubcategories(),
            knowledgeArea: this.knowledgeArea,
            competencies: this.competencies,
            difficulty: this.difficulty
          },
          paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          if (response.data) {
            response.data;
          }
          this.questions = response.data;

        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    getSubcategories() {
      if (this.subcategory) {
        return [this.subcategory]
      } else if (this.category) {
        return this.subCategoryList.map(subcategory => subcategory.value).filter(Boolean)
      } else {
        return []
      }
    },
    onModalHide() {
       this.questions= '';
    },
    showModal() {
      this.$refs['my-modal'].show();
    },
  },
  mounted() {
    this.loadDifficulty();
  },
  watch: {
    selectedTags: function () {
      this.loadQuestions();
    },
    'category'() {
      this.populateSelectSubcategories();
    },
  },
}
</script>



<style scoped>

</style>
